import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { firstAllowedRoute, hasModule } from "@/lib/auth";
import { VasCodesClient } from "@/features/warehouse/VasCodesClient";
import { listVasCodes, vasCodeKeys } from "@/features/warehouse/vasCodes.api";

// Warehouse → VAS (docs/wms-fc-optimus.md §7.4 stap 12): every VAS code and what WLX does with it. Reading is
// wms_masterdata; changing what a code does is for admins, like the settings — on the API regardless.
export const Route = createFileRoute("/_shell/warehouse/vas")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "wms_masterdata") && !hasModule(context.session, "wms_masterdata_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: VasScreen,
});

function VasScreen() {
  const { session } = Route.useRouteContext();
  const query = useQuery({ queryKey: vasCodeKeys.all, queryFn: listVasCodes });
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Warehouse VAS Codes">
      <VasCodesClient
        codes={query.data?.vasCodes ?? []}
        isLoading={query.isLoading}
        error={query.error}
        userId={session.userId}
        canEdit={session.roles.includes("admin")}
      />
    </div>
  );
}
